import {
  Sprite,
  Point,
  Graphics,
  Text,
} from 'pixi.js';
import WebGLElement from './WebGLElement';
import overlay from '.';
import { getRatio } from '../utils';
import store from '@/store';

class WebGLMarquee extends WebGLElement {
  constructor(component, element, inner, title) {
    super(component, element);

    this.element = element;
    this.inner = inner;

    this.sprite = null;
    this.texts = [];

    this.loadedHandler = () => {
      this.sprite = new Sprite();

      const rect = this.inner.getBoundingClientRect();
      this.background = new Graphics();
      this.background.beginFill(store.state.mode === 'estate' ? 0x000000 : 0xffffff)
        .drawRect(0, 0, rect.width, rect.height)
        .endFill();
      this.sprite.addChild(this.background);

      for (let index = 0; index < 2; index += 1) {
        const text = new Text(title, {
          fontFamily: 'VHS',
          fontSize: 120 * getRatio().x,
          fill: store.state.mode === 'estate' ? 0xffffff : 0x000000,
        });
        this.texts.push(text);
        this.sprite.addChild(text);
      }

      this.sprite.filters = [overlay.ref.displace];
      this.setProps();
      overlay.ref.push(this);
    };
    window.addEventListener('webgl-loaded', this.loadedHandler);
  }

  init() {
    this.element.style.visibility = 'hidden';

    this.render(true);
    this.renderHandler = () => { this.render(); };
    window.addEventListener('render', this.renderHandler);
  }

  setProps() {
    this.sprite.anchor = new Point(0.5, 0.5);
    this.texts.forEach((text, index) => {
      text.anchor = new Point(0, 0.5);
      text.positionOffset = text.width * index;
      text.position.x = text.positionOffset;
    });
  }

  render(first = false) {
    if (this.component.$el.dataset.inViewport !== '' && !first) {
      this.sprite.visible = false;
      this.sprite.renderable = false;
      return;
    }
    this.sprite.visible = true;
    this.sprite.renderable = true;
    const rect = this.inner.getBoundingClientRect();
    this.sprite.position.x = rect.left;
    this.sprite.position.y = rect.top;
    this.texts.forEach((text) => {
      text.position.y = rect.height / 2;
      text.position.x -= 4;
      if (text.position.x < -text.width) text.position.x = text.width;
    });
  }

  resize() {
    this.render(true);
  }

  initial() { }

  in() { }

  destroy() {
    window.removeEventListener('webgl-loaded', this.loadedHandler);
    window.removeEventListener('render', this.renderHandler);
    this.mask.destroy();
    this.lightNoise.destroy();
    this.lightWhite.destroy();
    if (this.price) this.price.destroy();
    if (this.priceExclusions) this.priceExclusions.destroy();
    this.sprite.destroy({ children: true });
  }
}

export default WebGLMarquee;
